const KeenSlider = window.KeenSlider
const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins

class SectionCollabsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'free',
        rubberband: false,
        slides: {
          perView: 'auto',
          spacing: 30,
        },
        defaultAnimation: {
          duration: 3000,
          easing: t => t,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 'auto',
              spacing: 80,
            },
          },
        },
      },
      [setInitialised(), useAutoplay(0, { pauseOnHover: false })],
    )
  }
}

if (!customElements.get('section-collabs-carousel')) {
  customElements.define('section-collabs-carousel', SectionCollabsCarousel)
}
